import React, { FC, memo, useState } from 'react';
import styles from './GuideArticleBlock.module.scss';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import LazyImage from '@/components/common/lazy-image';
import dayJs from 'dayjs';
import { useLanguage } from '@/hooks/use-language';
import { AppState } from '@/store';
import { XyzTransition } from '@animxyz/react';
import Image from 'next/image';
import Link from 'next/link';

type Props = {
  className?: string;
  onClick?: () => void;
  pageData?: any;
};

const GuideArticleBlock: FC<Props> = memo(({ onClick, className, pageData }: any) => {
  const router = useRouter();
  const language = useLanguage();

  const goToSearch = async (e: any) => {
    e.stopPropagation();
    await router.push({ pathname: `${language !== 'en' ? 'zh' : 'en'}/blog/search` });
  };

  const blogSnippet = pageData?.article?.length ? pageData?.article[0]?.blog_snippet : {};
  const category = blogSnippet?.category || [];
  const categoryReference = category?.length > 0 ? category[0] : {};

  const [scrollLeft, setScrollLeft] = useState(0);
  const handleScroll = (event: any) => {
    const { scrollLeft } = event.target;
    setScrollLeft(scrollLeft);
  };

  // const categoryUrl =
  //   (category?.length > 0 &&
  //     category[0] &&
  //     category[0]?.url &&
  //     category[0]?.url.replace(/\/([^/]+)\//, '$1')) ||
  //   'category';
  const articleUrl = `/${language !== 'en' ? 'zh' : 'en'}/blog/guide/${pageData?.article[0]?.url}`;

  return (
    <>
      <XyzTransition appearVisible xyz=" delay-1 fade-100% down-2">
        <Link href={articleUrl} className={classNames(styles.guide_article_block, className)}>
          <div className={styles.Image_Container}>
            <LazyImage
              src={pageData?.icon_mobile_1?.url}
              className={styles.Image}
              width={'100%'}
              height={'100%'}
              alt={blogSnippet.banner_alt_tag}
            />
          </div>
          <div className={styles.Article_Element}>
            <div className={styles.Category_Date_Rate}>
              <div className={styles.Category}>{categoryReference?.title}</div>

              <div className={styles.Date_Rate}>
                <div className={styles.Date}>
                  <Image
                    src="/blog/icon/Calendar.svg"
                    className={styles.Calendar}
                    alt={''}
                    width={12}
                    height={12}
                  />
                  {language !== 'en' ? (
                    <span>{dayJs(blogSnippet.last_update_date).format('YYYY年M月D日')}</span>
                  ) : (
                    <span>{dayJs(blogSnippet.last_update_date).format('D MMM YYYY')}</span>
                  )}
                </div>
                <div className={styles.Items_Center}>
                  <Image
                    src="/blog/icon/Star.svg"
                    className={styles.Star}
                    alt={''}
                    width={12}
                    height={12}
                  />
                  <span>
                    {blogSnippet.blog_rating && blogSnippet.blog_rating < 5
                      ? blogSnippet.blog_rating?.toFixed(1)
                      : '5.0'}
                  </span>
                </div>
              </div>
            </div>

            <div className={styles.Content_Info}>
              <h4 className={styles.Title}>{blogSnippet.blog_title}</h4>
              <div className={styles.Content}>{blogSnippet.description}</div>
              <div className={styles.Tags} onScroll={handleScroll}>
                {blogSnippet.topic_tags && blogSnippet.topic_tags[0]?.title ? (
                  <span className={styles.Tag} onClick={e => goToSearch(e)}>
                    {blogSnippet.topic_tags[0].title}
                  </span>
                ) : (
                  ''
                )}
                {blogSnippet.product_tags && blogSnippet.product_tags[0]?.title ? (
                  <span className={styles.Tag} onClick={e => goToSearch(e)}>
                    {blogSnippet.product_tags[0].title}
                  </span>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </Link>
      </XyzTransition>
    </>
  );
});

export default GuideArticleBlock;
